<template>
  <div class="about">
    <h1>Contact Us</h1>
    <p>Email contact.rtl@lifertl.com if you require any assistance.</p>
  </div>
</template>
<script>
export default {
  name: "Contact",
  mounted: function() {
    window.scrollTo(0, 0);
  }
};
</script>
